import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { ExtraAction } from './ExtraAction';

export function EditAction({ to }) {  
  return <ExtraAction to={to} tooltip="Edit" icon={<EditRoundedIcon />} />
}